import axios from 'axios';
import { API_BASE_URL } from '../../../config';

/**
 * One page of a person's activity timeline.
 * userId omitted => the signed-in user's own timeline.
 * @returns {Promise<{entries: object[], next_cursor: string|null, has_admin_activity: boolean}>}
 */
export async function fetchActivity({ userId, who = 'all', category = null, before = null, limit } = {}) {
  const path = userId ? `/api/profile/${userId}/activity` : '/api/profile/activity';
  const params = { who };
  if (category) params.category = category;
  if (before) params.before = before;
  if (limit) params.limit = limit;
  const { data } = await axios.get(`${API_BASE_URL}${path}`, { params, withCredentials: true });
  return data;
}
